import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import CallStatusBadge from '../../ai-assistant/components/CallStatusBadge';

const CallSummaryModal = ({ isOpen, onClose, title, date, status, text }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="fixed inset-0 z-100 flex items-center justify-center bg-black/50 p-4"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="call-summary-dialog-title"
    >
      <div
        className="bg-card rounded-lg border border-border shadow-elevation-lg max-w-lg w-full p-6 max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 mb-4">
          <div>
            <h2 id="call-summary-dialog-title" className="text-lg font-semibold text-foreground">
              {title}
            </h2>
            {(date || status) && (
              <div className="flex flex-wrap items-center gap-2 mt-1">
                {date && (
                  <p className="text-sm text-muted-foreground">{date}</p>
                )}
                {status ? <CallStatusBadge status={status} /> : null}
              </div>
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
            aria-label={t('common.close')}
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="overflow-y-auto">
          <p className="text-sm text-foreground leading-relaxed whitespace-pre-wrap">
            {text}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CallSummaryModal;
